import { render, staticRenderFns } from "./LinkSubPart.vue?vue&type=template&id=2d67e45c&scoped=true&"
import script from "./LinkSubPart.vue?vue&type=script&lang=ts&"
export * from "./LinkSubPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67e45c",
  null
  
)

export default component.exports